import { FinancialStatementPeriod } from 'common/types/financials';

const getPrevYearColumn = ({
  columnIndex,
  column,
  alphabet,
}: {
  columnIndex: number;
  column: FinancialStatementPeriod;
  alphabet: string[];
}) => column.isParent && alphabet[columnIndex - 1];

export default getPrevYearColumn;
